import { proxy } from "../../store/tools/fetchTools";

export const imagePath = (item: string) => `${proxy}/api${item}`;
// `${isProduction ? proxy : ""}/api${item}`;
